import {useState} from "react";
import AboutDesktopTabBarItemText from "../../texts/aboutScreen/AboutDesktopTabBarItemText";

export default function AboutDesktopTabBarItem({item, isSelected, setSelectedTab}) {
    // Used in

    // PROPERTIES
    const [isHovered, setIsHovered] = useState(false)

    // BUILD
    return (
        <div className={`cursor-pointer px-[2px] h-[36px] w-full flex items-center justify-start ${isSelected ? "border-b-2 border-greyLight11" : ""}`}
             onMouseEnter={() => setIsHovered(true)}
             onMouseLeave={() => setIsHovered(false)}
             onClick={setSelectedTab}>
            <AboutDesktopTabBarItemText text={item.title}
                                        isSelected={isSelected}
                                        isHovered={isHovered} />
        </div>
    );
}